import * as React from 'react'

import { ClockAlertIcon, MailCheckIcon } from 'lucide-react'
import { inject, observer } from 'mobx-react'

import { AuthStatus } from '~/client/src/shared/components/AuthLayout'
import { Button } from '~/client/src/shared/components/Button/Button'
import Spinner from '~/client/src/shared/components/Spinner/Spinner'

import Localization from '../../localization/LocalizationManager'
import AuthenticationStore from '../../stores/domain/Authentication.store'
import CommonStore from '../../stores/ui/Common.store'
import ExpiredInviteKeyInfoStore from './ExpiredInviteKeyInfo.store'

interface IProps {
  expiredInviteKey: string

  auth?: AuthenticationStore
  common?: CommonStore
}

@inject('auth', 'common')
@observer
export default class ExpiredInviteKeyInfo extends React.Component<IProps> {
  private readonly store: ExpiredInviteKeyInfoStore = null

  public constructor(props: IProps) {
    super(props)

    this.store = new ExpiredInviteKeyInfoStore(
      props.expiredInviteKey,
      props.auth,
      props.common,
    )
  }

  public render() {
    const {
      expiredInvitationTitle,
      expiredInvitationDescription,
      invitationResentTitle,
      invitationResentDescription,
    } = Localization.translator.loginInfoPageDescriptions

    const { wasInviteResent, durationOfInviteKeyInHours } = this.store

    return (
      <AuthStatus
        icon={wasInviteResent ? <MailCheckIcon /> : <ClockAlertIcon />}
        tone={wasInviteResent ? 'success' : 'neutral'}
        title={wasInviteResent ? invitationResentTitle : expiredInvitationTitle}
        description={
          wasInviteResent
            ? invitationResentDescription
            : expiredInvitationDescription(durationOfInviteKeyInHours)
        }
        isLive
      >
        {this.action}
      </AuthStatus>
    )
  }

  private get action(): JSX.Element {
    const { wasInviteResent, isLoading, handleClose, handleResendInvitation } =
      this.store

    if (wasInviteResent) {
      return (
        <Button className="tw:w-full" onClick={handleClose}>
          {Localization.translator.backToLogin}
        </Button>
      )
    }

    return (
      <Button
        className="tw:w-full"
        disabled={isLoading}
        focusableWhenDisabled
        onClick={handleResendInvitation}
      >
        {isLoading && (
          <span data-icon="inline-start" className="tw:inline-flex">
            <Spinner size="sm" variant="white" />
          </span>
        )}
        {
          Localization.translator.loginInfoPageDescriptions
            .resendMyInvitationLink
        }
      </Button>
    )
  }
}
